import React, { useContext, useEffect, useState } from 'react'
import { Fragment } from 'react';
import { AuthContext } from '../../../App/App';
import { MessageContext } from './Message';
import InfiniteScroll from "react-infinite-scroll-component";
import axios from 'axios'
import swal from 'sweetalert';
import jwt from 'jwt-decode'

function MessageList() {
    const { stateAuth, dispatchAuth } = useContext(AuthContext);
    const { stateMessage, dispatchMessage } = useContext(MessageContext);
    const jwtHelpdesk = jwt(localStorage.getItem('token-helpdesk-umy'))

    const handleClickMessage = (id) => {
        dispatchMessage({
            type: 'SHOW_CHAT',
            showChat: true,
            selected: id
        })
    }

    const hadnleFeedbackButton = (event, id) => {
        event.stopPropagation()
        feedbackDetail(id)
    }

    const feedbackDetail = (id) => {
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            }
        }
        axios.get(`/api/v1/helpdesk/message/chat/feedback/${id}`, config)
            .then(res => {
                //assign ratting and feedback
                dispatchMessage({
                    type: 'MODAL_FEEDBACK',
                    modalFeedback: { status: true, data: res.data.data }
                })
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again!!!'
                        })
                    } else if (err.response.data.message) {
                        swal("Error!", `${JSON.stringify(err.response.data.message)}`, "error", {
                            button: "OK",
                        });
                    }
                }
            })
    }

    const addMessage = () => {
        //check previous chat ratting is null
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            }
        }
        axios.get(`/api/v1/helpdesk/message/previous/${Number.isInteger(jwtHelpdesk.role_id) ? 'admin' : jwtHelpdesk.role_id}/${jwtHelpdesk.id}`, config)
            .then(res => {
                dispatchMessage({
                    type: 'PREV_CHAT',
                    prevChat: res.data.data
                })
                // console.log(res.data.data.length)

                if (res.data.data.length > 0 && res.data.data.find(chat => chat.status.id === 3) !== undefined) {
                    //assign ratting and feedback
                    swal("Warning!", "Please complete ratings and feedback before starting a new question.", "warning", {
                        button: "OK",
                    });
                    dispatchMessage({
                        type: 'MODAL_FEEDBACK',
                        modalFeedback: { status: true, data: res.data.data[0] }
                    })
                } else {
                    dispatchMessage({
                        type: 'NEW_CHAT',
                        modal: true
                    })
                }
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again!!!'
                        })
                    } else if (err.response.data.message) {
                        swal("Error!", `${JSON.stringify(err.response.data.message)}`, "error", {
                            button: "OK",
                        });
                    }
                }
            })
    }

    const [fetching, setfetching] = useState(false)

    const fetchMoreData = () => {
        if (fetching != null) {
            setfetching(true)
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'x-access-token': localStorage.getItem('token-helpdesk-umy')
                }
            }
            axios.get(`/api/v1/helpdesk/message/chats/${jwtHelpdesk.role_id == 'student' ? 'student' : jwtHelpdesk.role_id == 'staff' ? 'staff' : 'admin'}/${jwtHelpdesk.id}/${stateMessage.listMessages.row}`, config)
                .then(async res => {
                    //filter same message
                    setfetching(res.data.data.length < 20 ? null : false)
                    let cleanMessage = stateMessage.listMessages.content.concat(res.data.data);
                    let sameID = {}
                    cleanMessage = cleanMessage.filter(function (currentObject) {
                        if (currentObject.id in sameID) {
                            return true
                        } else {
                            sameID[currentObject.id] = true;
                            return true
                        }
                    })
                    //sort
                    cleanMessage = cleanMessage.sort((a, b) => b.time.localeCompare(a.time))
                    dispatchMessage({
                        type: 'LIST_CHATS',
                        listMessages: {
                            content: cleanMessage,
                            row: stateMessage.listMessages.row + 20
                        }
                    })

                })
                .catch(err => {
                    setfetching(false)

                    if (!err.response || err.code === 'ECONNABORTED') {
                        swal("Error!", "Check Your Internet Connection!", "error", {
                            button: "OK",
                        });
                    } else if (err.response) {
                        if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                            dispatchAuth({
                                type: "LOGOUT",
                                message: 'Token expired, please login again!!!'
                            })
                        } else if (err.response.data.message) {
                            swal("Error!", `${JSON.stringify(err.response.data.message)}`, "error", {
                                button: "OK",
                            });
                        }
                    }
                })
        }
    }

    //init
    useEffect(() => {
        if (stateMessage.listMessages.row == 0) {
            //get list -> masukkan dalam temp mesasge -> update count
            fetchMoreData()
        }
    }, [stateMessage.listMessages])

    useEffect(() => {
        if (stateMessage.trigger.message == "helpdesk-chat" && (stateMessage.trigger.action.name == 'attachment' || stateMessage.trigger.action.name == 'message')) {
            if (stateMessage.trigger.data == 'success') {
                const tempList = {
                    action: "update",
                    id: stateMessage.trigger.action.data.input.parent_chat,
                    status: {
                        id: (stateMessage.trigger.action.data.input.chat_type.sender == 'admin' ? 4 : 1),
                        name: (stateMessage.trigger.action.data.input.chat_type.sender == 'admin' ? "belum ditanggapi" : "proses")
                    },
                    message: stateMessage.trigger.action.data.input.message,
                    attachment: stateMessage.trigger.action.data.input.title,
                    time: stateMessage.trigger.action.data.input.time
                }
                dispatchMessage({
                    type: 'TEMP_LIST',
                    tempListMessage: tempList,
                })
            }
            // else if (stateMessage.trigger.data == 'error') {
            // }
        } else if (stateMessage.trigger.data == 'success' && stateMessage.trigger.message == "helpdesk-user-feedback-close" && stateMessage.trigger.action.data.sender == 'admin') {
            const tempList = {
                action: "status",
                id: stateMessage.trigger.action.data.chat_id,
                status: {
                    id: stateMessage.trigger.action.data.status_id,
                    name: ''
                },
            }
            dispatchMessage({
                type: 'TEMP_LIST',
                tempListMessage: tempList,
            })
        }
    }, [stateMessage.trigger])

    const [renderMessages, setRenderMessages] = useState(<Fragment />)
    useEffect(() => {
        if (stateMessage.tempListMessage != null) {
            let cleanList = stateMessage.listMessages.content
            if (stateMessage.tempListMessage.action == "update") {
                //update list
                const index = cleanList.findIndex(list => list.id == stateMessage.tempListMessage.id)
                if (cleanList[index] != undefined) {
                    cleanList[index].status.id = stateMessage.tempListMessage.status.id
                    cleanList[index].status.name = stateMessage.tempListMessage.status.message
                    cleanList[index].message = stateMessage.tempListMessage.message
                    cleanList[index].attachment = stateMessage.tempListMessage.attachment
                    cleanList[index].time = stateMessage.tempListMessage.time

                    //sort
                    cleanList = cleanList.sort((a, b) => b.time.localeCompare(a.time))
                }

            } else if (stateMessage.tempListMessage.action == "create") {
                //delete duplicate
                cleanList = cleanList.concat(stateMessage.tempListMessage.data);
                let sameID = {}
                cleanList = cleanList.filter(function (currentObject) {
                    if (currentObject.id in sameID) {
                        return true
                    } else {
                        sameID[currentObject.id] = true;
                        return true
                    }
                })
                //sort
                cleanList = cleanList.sort((a, b) => b.time.localeCompare(a.time))

            } else if (stateMessage.tempListMessage.action == "feedback") {
                const index = cleanList.findIndex(list => list.id == stateMessage.tempListMessage.id)
                cleanList[index].status.id = stateMessage.tempListMessage.status.id
                cleanList[index].status.name = stateMessage.tempListMessage.status.message
                cleanList[index].ratting = stateMessage.tempListMessage.ratting
                cleanList[index].feedback = stateMessage.tempListMessage.feedback
            } else if (stateMessage.tempListMessage.action == "status") {
                const index = cleanList.findIndex(list => list.id == stateMessage.tempListMessage.id)
                cleanList[index].status.id = stateMessage.tempListMessage.status.id
                cleanList[index].status.name = stateMessage.tempListMessage.status.message
            }
            //update list
            dispatchMessage({
                type: 'LIST_CHATS',
                listMessages: {
                    content: cleanList,
                    row: stateMessage.listMessages.row
                }
            })
            //reset temp list
            dispatchMessage({
                type: 'TEMP_LIST',
                tempListMessage: null,
            })
        }
    }, [stateMessage.tempListMessage])


    useEffect(() => {
        if (stateMessage.listMessages.content.length > 0) {
            function renderStar(count) {
                const star = []
                for (var i = 0; i < 5; i++) {
                    star.push(<i className="fas fa-star" style={{ color: `${i < count ? 'yellow' : '#fff'}`, textShadow: '-1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000' }} key={i} />)
                }
                return star
            }

            setRenderMessages(
                <div id="scrollableDiv" style={{ height: '100%', overflow: 'auto', }}>
                    <InfiniteScroll
                        dataLength={stateMessage.listMessages.content.length}
                        next={fetchMoreData}
                        hasMore={true}
                        loader={<h4>{fetching ? '...loading' : ''}</h4>}
                        endMessage={
                            <p style={{ textAlign: "center" }}>
                                <b>Yay! You have seen it all</b>
                            </p>
                        }
                        scrollableTarget="scrollableDiv"
                    >
                        {stateMessage.listMessages.content.map(msg => (
                            <div key={msg.id} className="ticket-item pt-1 pb-2 pl-0 pr-0 mb-0" style={{ borderBottom: 'solid 1px', borderColor: '#a6ada6' }} onClick={() => handleClickMessage(msg.id)}>
                                <div className="p-0 m-0" >
                                    <div className="row col-12 pr-1" >
                                        <div className="col-auto pr-2 pl-0">
                                            <div className="avatar-item">
                                                <img alt="image" src="../assets/img/avatar/avatar-1.png" className="img-fluid pr-0" width="50" data-toggle="tooltip" title={msg.workunit.name} />
                                                {msg.status.id != 1 ? (<div className="avatar-badge" title={msg.status.id == 4 ? 'New Message' : msg.status.id == 2 ? 'Panding' : 'Done'} data-toggle="tooltip"><i className={`fas fa-comment-alt text-${msg.status.id == 4 ? 'danger' : msg.status.id == 2 ? 'warning' : 'success'}`} style={{ fontSize: '1em', textShadow: '-1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff' }}></i></div>) : ''}
                                            </div>
                                        </div>
                                        <div className="media-body col-mx-auto  pl-0 ml-0 mr-0 pr-0">
                                            <div className="ticket-title  mb-0 pb-0">
                                                <b style={{ fontSize: '0.8em', marginBottom: '0px' }}>{msg.workunit.name}<small className="pt-1" style={{ float: 'right', fontSize: '0.7em' }}>{`${new Date(msg.time).toISOString().replace(/T/, ' ').replace(/\..+/, '').substring(0, new Date(msg.time).toISOString().replace(/T/, ' ').replace(/\..+/, '').length - 3)}`}</small> </b>
                                            </div>
                                            <div style={{ float: 'right' }}>
                                                {msg.ratting != null ? renderStar(msg.ratting) : msg.status.id == 3 ? (<p style={{ color: '#fff', textTransform: 'capitalize' }} className="btn  btn-sm btn-icon icon-left btn-primary p-0 m-0" onClick={(e) => hadnleFeedbackButton(e, msg.id)} >Give Rating</p>) : (<p style={{ fontWeight: 'bold', color: '#fff', textTransform: 'capitalize' }} className="btn  btn-sm btn-icon icon-left btn-danger p-0 m-0" onClick={(e) => hadnleFeedbackButton(e, msg.id)} > Close Chat </p>)}
                                            </div>
                                            <div className="ticket-desc mb-0  pb-0">
                                                <div className="mb-0">
                                                    <p style={{ fontSize: '1.2em', marginBottom: '0px' }}>{msg.status.id == 3 ? msg.category.name : msg.attachment != null ? (<Fragment><i className="fas fa-paperclip"></i> {msg.message.length >= 32 ? `${msg.message.substring(0, 52)}....` : msg.message}</Fragment>) : msg.message.length >= 32 ? `${msg.message.substring(0, 52)}....` : msg.message}  </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </InfiniteScroll>
                </div>
            )
        } else {
            setRenderMessages(<Fragment />)
        }
    }, [stateMessage.listMessages])

    return (
        <Fragment>
            <div className="section-title mt-0 pb-0">
                {stateAuth.page}
                <button onClick={() => addMessage()} className="btn  btn-lg btn-icon icon-left btn-success float-right" style={{ color: '#fff', fontWeight: 'bold', textTransform: 'capitalize', borderRadius: '30px' }}><i className="fas fa-pen"></i>New Chat</button>
            </div>
            <div className="tickets" >
                <div className="ticket-items col-12 p-0 m-1"  >
                    <div className="card chat-box col-12 card-success m-0 p-0" id="mychatbox2">
                        <div className="card-body chat-content-chat pl-2 pr-2 overflow-auto" style={{ minHeight: '80vh' }}>
                            {renderMessages}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default MessageList
